import { ErroApi } from '@entregas/api';
import { ProvedorApi } from '@entregas/api/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useState } from 'react';
import { obterDb } from './db';
import { ProvedorSessao } from './sessao';

function criarQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 20_000,
        // Erro de regra (código conhecido) não melhora tentando de novo; rede sim.
        retry: (tentativas, erro) =>
          tentativas < 2 && (!(erro instanceof ErroApi) || erro.codigo === 'sem_conexao'),
        refetchOnWindowFocus: true,
      },
      // Sem rede a gravação falha na hora e a tela diz isso; pausada, ela voltaria sozinha mais tarde, sem ninguém ver.
      mutations: { retry: false, networkMode: 'always' },
    },
  });
}

export function Provedores({ children }: { children: ReactNode }) {
  const [qc] = useState(criarQueryClient);
  return (
    <QueryClientProvider client={qc}>
      <ProvedorApi db={obterDb()}>
        <ProvedorSessao>{children}</ProvedorSessao>
      </ProvedorApi>
    </QueryClientProvider>
  );
}
